import { apiRequest } from './client';

export const preferencesApi = {
  notification: () => apiRequest('/api/v1/me/notification-preferences'),
  updateNotification: (body) => apiRequest('/api/v1/me/notification-preferences', { method: 'PUT', body }),
  localization: () => apiRequest('/api/v1/me/localization-preferences'),
  updateLocalization: (body) => apiRequest('/api/v1/me/localization-preferences', { method: 'PUT', body }),
};

